import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

interface Spinner {
  font_size_loading?: string
  font_size_text?: string
  className?: string
  text?: string
}

const SpinnerLoading = ({
  text,
  className,
  font_size_loading = 'h-10 w-10 animate-spin text-slate-500',
  font_size_text = 'text-sm font-medium text-gray-500 mt-3 animate-pulse',
}: Spinner) => {
  return (
    <div className={`mt-5 text-center ${className && className}`}>
      <FontAwesomeIcon
        aria-hidden="true"
        className={`${font_size_loading}`}
        icon={faSpinner}
      />
      <h3 className={`${font_size_text}`}>{text ? text : 'Cargando...'}</h3>
    </div>
  )
}

export default SpinnerLoading
